import React from "react";
import { HStack } from "web/react/emo/h-stack";
import { Link } from "web/react/emo/link";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { ArticleCardSerializer } from "web/types/serializers";
import * as styles from "./in-feed-editorial-block.css";
import { PrimaryArticleCard } from "./primary-article-card";
import { SecondaryArticleCard } from "./secondary-article-card";

interface InFeedEditorialBlockProps {
    articles: ArticleCardSerializer[];
}

export function InFeedEditorialBlock({ articles }: InFeedEditorialBlockProps): React.ReactElement {
    const primaryArticle = articles[0];
    const secondaryArticles = articles.length > 1 ? articles.slice(1, 4) : null;

    const bodyDesktopTopMargin = articles.length > 1 ? "sm" : "md";
    const bodyDesktopBottomMargin = articles.length > 1 ? "xs" : "md";

    return (
        <View height="full" dataTestId="editorial-block" className={styles.editorialBlockContainer}>
            <View
                marginTop={{ sm: "xs", md: "xs", lg: bodyDesktopTopMargin }}
                marginBottom={{ sm: "xs", md: "xs", lg: bodyDesktopBottomMargin }}
            >
                <View marginBottom="sm">
                    <HStack justify="space-between" align="center">
                        <Text textStyle="body">{gettext("feed.editorial.recommended")}</Text>
                        <Link
                            title={gettext("site_links.view_all")}
                            href="/the-edit"
                            color="secondary"
                            dataTestId="editorial-block-view-all"
                        />
                    </HStack>
                </View>
                <View marginBottom="sm">
                    <PrimaryArticleCard {...primaryArticle} />
                </View>
                {secondaryArticles && (
                    <View className={styles.secondaryArticlesSectionContainer}>
                        {secondaryArticles.map((article) => (
                            <View key={article.slug} className={styles.secondaryArticleContainer}>
                                <SecondaryArticleCard {...article} />
                            </View>
                        ))}
                    </View>
                )}
            </View>
        </View>
    );
}
